<template>
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-8 mx-auto">
                <h2 class=" my-5 text-center">Get <span class="text-success">&pound;{{globalRewardAmount}}</span> for every friend that joins!</h2>
                <p class="text-center h5 font-weight-normal">Invite your Friends with your unique referral link and earn <span class="text-success">&pound;{{globalRewardAmount}}</span> for every one
                    who joins and switches with MySwitchPro.</p>
            </div>
            <div class="col-12">
                <hr class="my-5" />
                <h4 class="text-center">Your referral link</h4>
                <div class="row">
                    <div class="col-lg-6 mx-auto mt-4">
                        <div class="border rounded py-3 px-4 bg-white font-weight-bold shadow-sm d-flex flex-column flex-lg-row align-items-center justify-content-between">
                            <div v-html="formatReferralLink"></div>
                            <button class="btn btn-link float-right copy-link text-center text-lg-right mt-4 mt-lg-0" :data-clipboard-text="referralLink" >copy</button>
                        </div>
                        <div class="card shadow-sm my-4">
                            <div class="card-body">
                                <h5 class="text-center">Invite via:</h5>
                                <div class="d-flex justify-content-center mt-4 d-flex flex-column flex-sm-row align-items-center">
                                    <div class="mb-3">
                                        <button class="btn p-0 mx-1"
                                                @click="share(`https://www.linkedin.com/shareArticle?mini=true&url=${referralLink}`)">
                                            <img src="../../assets/images/social/linkedin.svg" alt="">
                                        </button>
                                        <button class="btn p-0 mx-1"
                                        @click="share(`https://www.facebook.com/dialog/share?app_id=2654318531454241&display=popup&href=${referralLink}`)">
                                            <img src="../../assets/images/social/facebook.svg" alt="">
                                        </button>
                                        <button class="btn p-0 mx-1"
                                        @click="share(`https://www.reddit.com/submit?url=${referralLink}&title=${shareText}`)">
                                            <img src="../../assets/images/social/reddit.svg" alt="">
                                        </button>
                                    </div>
                                    <div class="mb-3">
                                        <button class="btn p-0 mx-1"
                                        @click="share(`${whatsAppUrl}?text=${shareText} ${referralLink}`)">
                                            <img src="../../assets/images/social/whatsapp.svg" alt="">
                                        </button>
                                        <button class="btn p-0 mx-1"
                                        @click="share(`https://twitter.com/intent/tweet?url=${referralLink}&hashtags=energysavings,moneysaving,bills,energybills&text=${twitterText}`)">
                                            <img src="../../assets/images/social/twitter.svg" alt="">
                                        </button>
                                        <button class="btn p-0 mx-1"
                                        @click="share(`mailto:?subject=${$store.getters['auth/firstName']} ${$store.getters['auth/lastName']} via MySwitchPro&body=${shareText} ${referralLink}`)">
                                            <img src="../../assets/images/social/email.svg" alt="">
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <h4 class="text-center my-4">My rewards</h4>
                <div class="card shadow-sm mb-4">
                    <div class="card-body p-3 p-lg-5">
                        <referrals-list />
                        <rewards-list />
                    </div>
                </div>
            </div>
        </div>
        <modal ref="modal" :dialog-class="['modal-sm', 'mx-auto']">
           <div class="d-flex flex-column align-items-center justify-content-center">
               <img src="../../assets/images/check.svg" alt="">
               <h3 class="text-success m-4">Copied!</h3>
           </div>
        </modal>
    </div>
</template>

<script>
import Clipboard from "clipboard/dist/clipboard";
import Modal from "../../components/Modal";
import ReferralsList from "@/components/profile/ReferralsList";
import RewardsList from "@/components/profile/RewardsList";
import RewardHelper from "@/mixins/RewardHelper";
import api from "@/utils/api";
import store from "@/store";
const mobile = require('is-mobile')

const moment = require('moment');
    export default {
        name: "Rewards",
        components: {RewardsList, ReferralsList, Modal},
        mixins: [RewardHelper],
        data: function() {
          return {
              clipboard: null,
          }
        },
        methods: {
            share(url) {
                if (url.startsWith('mailto')) {
                    window.location.href = url;
                    return;
                }
                let win = null;
                if (this.platform === 'reddit') {
                    win = window.open(url, '_blank');
                } else {
                    win = window.open(url, this.title, 'height=500,width=900');
                }
                if (win && window.focus) {
                    win.focus()
                }
            }
        },
        filters: {
            dateFormat: function (date) {
                return moment(date * 1000).format('DD/MM/YY')
            }
        },
        computed:{
            shareText() {
              return encodeURI('Hi\n' +
                  '\n' +
                  'I have recently found a new energy switching site MySwitchPro – they search energy suppliers for the best deals then switch you automatically every time there is a better deal! Its saving me a fortune – check them out using my personalised link:')
            },
            twitterText(){
              return  encodeURI('Check out this new #easyswitching site @MySwitchPro – they search #energy suppliers for the #bestdeals, then switch you automatically every time there is a better deal! It’s saving me a fortune:').replace(/#/g, '%23')
            },
            referralLink: function (){
                 const resolved =this.$router.resolve({name: 'ReferralLanding', params: { code: this.$store.getters['auth/referralCode']}});

                 return window.location.origin+resolved.href
            },
            formatReferralLink: function (){
                let parts = this.referralLink.split('/')
                let code = '<span class="text-success">'+parts.pop()+'</span>';
                parts.push(code)
                return parts.join('/')
            },
            whatsAppUrl: function () {
                if (mobile()) {
                    return 'whatsapp://send'
                }
        
                return 'https://web.whatsapp.com/send'
            }
        },
        mounted() {
            this.clipboard = new Clipboard('.copy-link');
            let that = this;
            this.clipboard.on('success', function () {
                that.$refs.modal.show();
                setTimeout(function () {
                    that.$refs.modal.hide();
                }, 1000)
            });
            
        },
        destroyed() {
            this.clipboard.destroy();
        },
        beforeRouteEnter: (to, from, next) => {
            api.balance().then(response => {
                store.commit('auth/balance', response.data.data.balance);
            })
            next();
        }
    }
</script>

<style scoped lang="scss">
@import "../../sass/base";
    .list-group > .list-group-item {
        background: linear-gradient(180deg, #FFFFFF 0%, #FAFAFA 100%);
    }

    ::v-deep {
        .modal-sm {
            max-width: 200px;
        }
    }
</style>
